import { AboutCompanyData } from "../types/about-company-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getAboutScript = async (exchId: string, formattedSymbol: string) => {
  const response: AboutCompanyData = await request({
    method: "GET",
    url: `${API_PATHS.aboutScript}?exchId=${exchId}&formattedSymbol=${formattedSymbol}`,
  });
  return response;
};
